window.addEventListener('DOMContentLoaded', _ => {
  try {
    const header = document.getElementById('header')
    
    if (header) {
      const bar = header.querySelector('.header__bar')
      const containers = document.querySelectorAll('.container')
      
      let options = {
        rootMargin: '0px 0px -100% 0px',
        threshold: 0
      }
      
      let observer = new IntersectionObserver(callback, options);
      
      containers.forEach(container => {
        observer.observe(container)
      })
    
      
      function callback(entries) {
        entries.forEach(entry => {    
          if ( entry.isIntersecting ) {
            if ( entry.boundingClientRect.y <= 0 ) {
              bar.dataset.mode = entry.target.dataset.mode ? entry.target.dataset.mode : 'primary'
            }
          }
        })
      }
    }
  } catch (error) {
    console.log('Bar mode shifting will only occur on front end.')
  }
});

window.addEventListener('DOMContentLoaded', _ => {
  try {
    const header = document.getElementById('header')
    const nav = header.querySelector('#primary-navigation')
    
    if (header) {
      const toggle = header.querySelector('#navigation-toggle')
      if ( toggle ) {
        toggle.addEventListener('click', () => {
          if ( toggle.dataset.toggled === "0" ) {
            toggle.dataset.toggled = "1"
            nav.dataset.expanded = "1"
            disableScroll()
          } else {
            toggle.dataset.toggled = "0"
            nav.dataset.expanded = "0"
            enableScroll()
          }
        })
      }
    }
  } catch (error) {
    console.log('Navigation toggling will only occur on front end.')
  }
});

function disableScroll() {
  // Get the current page scroll position
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  document.documentElement.style.overflow = 'hidden';  // firefox, chrome
  document.body.scroll = "no"; // ie only
  // if any scroll is attempted, set this to the previous value
  window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
  };
}

function enableScroll() {
  document.documentElement.style.overflow = 'auto';  // firefox, chrome
  document.body.scroll = "yes"; // ie only
  window.onscroll = function() {};
}